const GeneralInformationConstants ={
  WARNING: "warning",
  REQUESTDATA_LENGTH_2: 2,
};

export default GeneralInformationConstants